// extracted by mini-css-extract-plugin
export default {"container-main":"templates-register-error-module__container-main"};